import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  position: fixed;
  z-index: 100000;
`;
